import React from 'react';
import { withRouter } from 'react-router-dom';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import classNames from 'classnames';

const schoolLogoSizingStyles = {
  imageSize: (props) => ({
    width: props.schoolLogoWidth,
    padding: props.schoolLogoPadding,
    justifyContent: props.horizontalAlign,
    height: 'auto',
  }),
  containerSize: (props) => ({
    width: props.schoolLogoContainerWidth,
    justifyContent: props.containerJustify,
    margin: props.containerMargin,
    minWidth: props.schoolLogoContainerMinWidth,
  }),
};

const SchoolLogo = (props) => {
  const logoLink =
    props.location.pathname.toLowerCase() !== '/asu/landing'
      ? props.tenant.logoLink
      : null;

  const poweredByLogo = props.poweredByLogoExists
    ? props.poweredByLogoExists
    : props.tenant.logo;

  const extraStyles = props.poweredByLogoExists ? 'asu-link' : 'corner';
  const introOrNotStyle = props.poweredByLogoExists
    ? 'school-logo-intro'
    : 'school-logo-intro-corner';

  return (
    <div
      className={['school-logo-container', props.classes.containerSize].join(
        ' '
      )}
    >
      {logoLink === null ? (
        <div className={extraStyles}>
          {/* <img
            className={classNames({
              [introOrNotStyle]: true,
              [`__${props.tenant.name.toLowerCase()}`]: true,
              [props.classes.imageSize]: true,
            })}
            src={poweredByLogo}
            alt={`${props.tenant.name} logo`}
          /> */}
          <picture>
            <source
              media="(max-width: 799px)"
              srcSet={poweredByLogo}
              width="480"
              height="400"
            />
            <source
              media="(min-width: 800px)"
              srcSet={poweredByLogo}
              width="800"
              height="400"
            />
            <img
              className={classNames({
                [introOrNotStyle]: true,
                [`__${props.tenant.name.toLowerCase()}`]: true,
                [props.classes.imageSize]: true,
              })}
              src={poweredByLogo}
              alt={`${props.tenant.name} logo`}
              width="800"
              height="400"
            />
          </picture>
        </div>
      ) : (
        <a
          className={extraStyles}
          href={logoLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className={classNames({
              [introOrNotStyle]: true,
              [`__${props.tenant.name.toLowerCase()}`]: true,
            })}
            src={poweredByLogo}
            alt={`${props.tenant.name} logo`}
          />
        </a>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const tenant = state.tenant;

  return { tenant };
};

export default withRouter(
  connect(mapStateToProps, {})(withStyles(schoolLogoSizingStyles)(SchoolLogo))
);
